import api from "./axios";
import { apiPaths } from "./paths";
import type {
  Project,
  ApiKeyCreated,
  ApiKeyDisplay,
  ApiMessage,
} from "@/types";

export const getProjects = () =>
  api.get<Project[]>(apiPaths.projects.list).then((r) => r.data);

export const getProject = (id: string) =>
  api.get<Project>(apiPaths.projects.one(id)).then((r) => r.data);

export const createProject = (data: Partial<Project>) =>
  api.post<Project>(apiPaths.projects.list, data).then((r) => r.data);

export const updateProject = (id: string, data: Partial<Project>) =>
  api.patch<Project>(apiPaths.projects.one(id), data).then((r) => r.data);

export const deleteProject = (id: string) =>
  api.delete<ApiMessage>(apiPaths.projects.one(id)).then((r) => r.data);

export const getApiKeys = (projectId: string) =>
  api
    .get<ApiKeyDisplay[]>(apiPaths.projects.apiKeys(projectId))
    .then((r) => r.data);

export const createApiKey = (
  projectId: string,
  data: { name: string; expiresAt?: string },
) =>
  api
    .post<ApiKeyCreated>(apiPaths.projects.apiKeys(projectId), data)
    .then((r) => r.data);

export const deleteApiKey = (projectId: string, keyId: string) =>
  api
    .delete<ApiMessage>(apiPaths.projects.apiKey(projectId, keyId))
    .then((r) => r.data);
